module.exports = __webpack_public_path__ + "static/logo-trans-ee2cc839ea2b40c402de634690906913.png";